/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */

export type ScreenName = (typeof ScreenName)[keyof typeof ScreenName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ScreenName = {
  TaskManagement: 'TaskManagement',
  TaskManagementSpike: 'TaskManagementSpike',
  NotificationCentre: 'NotificationCentre',
  PouchPreparation: 'PouchPreparation',
  RecordKnownVariance: 'RecordKnownVariance',
  WeeklyBalance: 'WeeklyBalance',
  MonthlyBalance: 'MonthlyBalance',
  DiscrepancyAccount: 'DiscrepancyAccount',
  WeeklyMonthlyBalanceHistory: 'WeeklyMonthlyBalanceHistory',
  PouchPreparationHistory: 'PouchPreparationHistory',
  SalesSummary: 'SalesSummary',
  TransactionLog: 'TransactionLog',
  TransactionViewer: 'TransactionViewer',
  EventLog: 'EventLog',
  ManageCashDrawer: 'ManageCashDrawer',
  BranchOverview: 'BranchOverview',
  CashMovementHistory: 'CashMovementHistory',
  CashCountHistory: 'CashCountHistory',
  NotesAndCoinOrdering: 'NotesAndCoinOrdering',
  PlannedOrdering: 'PlannedOrdering',
  BranchOverviewStock: 'BranchOverviewStock',
  StockCheck: 'StockCheck',
  ManualBookInStock: 'ManualBookInStock',
  StockOrdering: 'StockOrdering',
  StockMovementHistory: 'StockMovementHistory',
  StockCountHistory: 'StockCountHistory',
  BranchOverviewForex: 'BranchOverviewForex',
  ForexMovementHistory: 'ForexMovementHistory',
  ForexCountHistory: 'ForexCountHistory',
  ForexOrdering: 'ForexOrdering',
  RateBoardConfiguration: 'RateBoardConfiguration',
  ITIssues: 'ITIssues',
  FeedbackAndSupport: 'FeedbackAndSupport',
  VersionInfo: 'VersionInfo',
  OpeningAndClosingTimes: 'OpeningAndClosingTimes',
  EquipmentOrdering: 'EquipmentOrdering',
} as const;
